import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportKpiCharts } from '@api/kpi';

import { IExportKpiDTO } from '@interfaces/kpi/dto/kpiDTO';

import { ESnackbarTypes } from '@enums/common';

import { EXPORT_CHARTS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportKpiCharts = () => {
	const dispatch = useAppDispatch();

	const { mutate: exportCharts } = useMutation<Array<IExportKpiDTO>>({
		mutationKey: [EXPORT_CHARTS],
		mutationFn: (data: Array<IExportKpiDTO>) => exportKpiCharts(data),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportChartsSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		onError: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportChartsError,
				type: ESnackbarTypes.error,
			}));
		},
	});

	return { exportCharts };
};
